import { render, staticRenderFns } from "./IncompleteBackupsTable.vue?vue&type=template&id=6b38fe46&scoped=true&"
import script from "./IncompleteBackupsTable.vue?vue&type=script&lang=js&"
export * from "./IncompleteBackupsTable.vue?vue&type=script&lang=js&"
import style0 from "./IncompleteBackupsTable.vue?vue&type=style&index=0&id=6b38fe46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b38fe46",
  null
  
)

export default component.exports